const validateAndGetUrlWithOrgSlug = ({ me, orgSlug, url, fallbackUrl })=>{
    const slug = me?.organization?.slug || orgSlug;
    const defaultUrl = fallbackUrl || url;
    return slug ? `/org/${slug}${url}` : defaultUrl;
};
const utils_validateAndGetUrlWithOrgSlug = validateAndGetUrlWithOrgSlug;
export default utils_validateAndGetUrlWithOrgSlug;
export { validateAndGetUrlWithOrgSlug };
